import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: #fff;
  ${({ canvasScale }) => `
  column-gap: ${5 * canvasScale}px;
  `}
`;

const PaymentMethod = styled.div`
  background-image: url(${({ pm }) => pm});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  ${({ canvasScale }) => `
  padding: ${20 * canvasScale}px;
  border-radius: ${8 * canvasScale}px;
  `}
`;

export const PAYMENT_METHODS = [
  { id: "DINHEIRO", label: "Dinheiro", icon: "dinheiro" },
  { id: "PIX", label: "Pix", icon: "pix" },
  { id: "CARTAO_VISA", label: "Cartão Visa", icon: "visa" },
  { id: "CARTAO_MASTER", label: "Cartão Mastercard", icon: "mastercard" },
  { id: "CARTAO_ELO", label: "Cartão Elo", icon: "elo" },
  { id: "ALELO", label: "Cartão Alelo", icon: "alelo" },
  { id: "SODEXO", label: "Cartão Sodexo", icon: "sodexo" },
  { id: "TICKET", label: "Cartão Ticket", icon: "ticket" },
  { id: "HIPERCARD", label: "Cartão Hipercard", icon: "hipercard" },
  { id: "VR", label: "Cartão VR Benefícios", icon: "vr" },
];

const findPaymentMethodImage = (paymentMethod) => {
  const { icon } = PAYMENT_METHODS.find((pm) => pm.id === paymentMethod) || {};
  return `images/paymentMethod/${icon}.png`;
};

export default function PaymentMethodList({ methods, canvasScale, className }) {
  return (
    <Container
      className={`payment-methods-list ${className}`}
      canvasScale={canvasScale}
    >
      {methods?.map((method) => (
        <PaymentMethod
          canvasScale={canvasScale}
          key={method}
          className="payment-method"
          pm={findPaymentMethodImage(method)}
        />
      ))}
    </Container>
  );
}
